export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/tt.61a4ade0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};